import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AccessPolicyEnum, DefaultAccessPolicies, PermissionEnum} from "./permissions";
import {UserDataStoreService} from "../user-data-store.service";
import {ToastrService} from "ngx-toastr";
import {AccountTypeEnum} from "../../models/account-type-enum";


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _toastr: ToastrService
  ) {

  }

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this._userDataStore.currentUserValue) {
      let hasPermissions = await this.hasRequiredPermissions(route.data.permissions, route.data.policies);
      if(route.data.accountType != undefined && this._userDataStore.accountType != route.data.accountType){
          hasPermissions = false;
      }
      if(!hasPermissions){
        this._toastr.warning("You do not have the required permissions to view this page, please contact your administrator if you require access.", "Warning");
      }
      return hasPermissions;
    }
    // not logged in so redirect to login page with the return url
    await this._router.navigate(['account', 'login']);
    return false;
  }


  public async hasRequiredPermissions(permissions: PermissionEnum[], policies: AccessPolicyEnum[]): Promise<boolean> {
    const checker = (arr, target) => target.every(v => arr.includes(v));

    //Allow system admins all access
    if (this._userDataStore.accountType === AccountTypeEnum.SystemAdministrator) {
      return true;
    }

    let requiredPermissions = [];
    if (permissions) {
      requiredPermissions = [...permissions];
    }

    if (policies) {
      for (const policy of policies) {
        requiredPermissions = [...requiredPermissions, ...DefaultAccessPolicies[policy]];
      }
    }

    if (requiredPermissions && !checker(this._userDataStore.currentUserPermissions, requiredPermissions)) {
      // role not authorised so redirect to home page
      await this._router.navigate(['/']);
      return false;
    }
    // authorised so return true
    return true;
  }
}
